"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPersonalSubscriptionHandler = addPersonalSubscriptionHandler;
var AddPersonalSubscriptionFailed = _interopRequireWildcard(require("@ori-events/add-personal-subscription-failed"));
var AddToBasket = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var RemoveBasketItemFailed = _interopRequireWildcard(require("@ori-events/remove-basket-item-failed"));
var UpdateBasketItemFailed = _interopRequireWildcard(require("@ori-events/update-basket-item-failed"));
var _checkoutUtils = require("@ori/checkout-utils");
var _api = require("../api");
var _logger = require("../logger");
var _types = require("../types");
var _utils = require("../utils");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
async function addPersonalSubscriptionHandler({
  detail: {
    itemCode,
    items,
    frequency,
    placement,
    lineNumber,
    originalQuantity
  }
}, {
  client,
  sessionId,
  tenant
}) {
  // recheck if there is collection needed
  const globalShoppingPersonalSubscriptionDto = {
    itemCode,
    collection: items ?? [],
    frequency,
    status: 'New'
  };
  try {
    await (0, _api.addPersonalSubscription)({
      client,
      globalShoppingPersonalSubscriptionDto,
      sessionId,
      tenant,
      placement
    });
  } catch (error) {
    _logger.mainLogger.error(error, {
      message: 'Error while adding personal subscription in addPersonalSubscription event'
    });
    const errorEvent = new CustomEvent(AddPersonalSubscriptionFailed.Name, {
      detail: {
        isSuccess: false,
        localizedMessage: String(error),
        message: String(error)
      }
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  let response;

  // STEP 2 - Remove or reduce quanity of original item in basket
  if (typeof lineNumber === 'number' && originalQuantity !== undefined && originalQuantity > 1) {
    response = await fetch(`${_types.RequestUrl.UpdateBasketItem}?lineNumber=${lineNumber}&quantity=${originalQuantity - 1}`, (0, _utils.getHttpRequestSettings)({
      placement
    }));
  } else if (typeof lineNumber === 'number' && originalQuantity !== undefined && originalQuantity === 1) {
    response = await fetch(_types.RequestUrl.RemoveBasketItem, (0, _utils.getHttpRequestSettings)({
      lineNumber,
      placement
    }, _checkoutUtils.HttpMethod.Post));
  } else {
    // Basket update in case of no basket item manupulation
    response = await fetch(_types.RequestUrl.GetShoppingContext, (0, _utils.getHttpRequestSettings)(undefined, _checkoutUtils.HttpMethod.Post));
  }

  // STEP 3 - Update shopping context via Online endpoint
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if (AddPersonalSubscriptionFailed.isAddPersonalSubscriptionErrorResponse(data)) {
    const errorEvent = new CustomEvent(AddPersonalSubscriptionFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  } else if (RemoveBasketItemFailed.isRemoveBasketItemErrorResponse(data)) {
    const errorEvent = new CustomEvent(RemoveBasketItemFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  } else if (UpdateBasketItemFailed.isUpdateBasketItemErrorResponse(data)) {
    const errorEvent = new CustomEvent(UpdateBasketItemFailed.Name, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return {
    ...data,
    lastAddedItem: {
      itemCode,
      method: AddToBasket.Method.BUY_FOR_MONEY,
      quantity: 1,
      frequency
    }
  };
}